"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTruncatesString = exports.hasOwnProperty = void 0;
/**
 * We want to check if prop is a property key of obj
 * @param obj - object
 * @param prop - property
 * @link https://fettblog.eu/typescript-hasownproperty/
 */
function hasOwnProperty(obj, prop) {
    return obj.hasOwnProperty(prop);
}
exports.hasOwnProperty = hasOwnProperty;
function getTruncatesString(str, length) {
    if (str.length > length) {
        return [str.substr(0, length - 1), true];
    }
    return [str, false];
}
exports.getTruncatesString = getTruncatesString;
